import React, { useContext } from 'react';
import { updateTeachersRange } from '../../../actions';
import { Context } from '../../../defaults';
import { Divider, Table, Switch, message, Checkbox, Button } from 'antd';

const TeachersSwitcher = ({ teachers, setTeachers }) => {
  const { dictionary, language, setLoading } = useContext(Context);
  const columns = [
    {
      title: `№`,
      dataIndex: 'number',
      key: 'number',
      fixed: 'left',
      render: (text, record, index) => index + 1,
    },
    {
      title: `${dictionary?.FullName[language]}`,
      key: 'FIO',
      fixed: 'left',
      render: (text, record, index) => {
        return <span>{text.lastName + ' ' + text.firstName + ' ' + text.middleName}</span>;
      },
    },
    {
      title: `${dictionary?.Activity[language]}`,
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (text, record, index) => (
        <Switch checked={text?.users?.active} onChange={() => onChangeTeacherActive(text)} />
      ),
    },
  ];

  const onChangeTeacherActive = (e) => {
    const updatedTeachers = teachers.map((t) => {
      return t.id === e.id ? { ...t, users: { ...t.users, active: e?.users?.active ? 0 : 1 } } : { ...t };
    });
    setTeachers(updatedTeachers);
  };

  const onCheckAllChange = () => {
    const updatedTeachers = teachers.map((st) => {
      return {
        ...st, users: { ...st.users, active: checkAll() ? 0 : 1 }
      };
    });
    setTeachers(updatedTeachers);
  };

  const onSaveChanges = () => {
    setLoading(true);
    updateTeachersRange(teachers)
      .then(() => {
        setLoading(false);
        message.success(dictionary?.SuccessfullyAdded[language], 4);
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], 4);
        setLoading(false);
      });
  };

  const checkAll = () => {
    if (teachers.filter((st) => st?.users?.active === 1).length === teachers.length) {
      return 1;
    }
    return 0;
  };

  return (
    <>
      <Divider orientation="left">
        {dictionary?.TeacherList[language]}
        <Checkbox
          onChange={onCheckAllChange}
          checked={checkAll()}
          disabled={teachers.length === 0}
          style={{ marginLeft: 20 }}>
          {dictionary?.SelectAll[language]}
        </Checkbox>
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => onSaveChanges()}
          disabled={teachers.length === 0}
          style={{ marginLeft: 40 }}>
          {dictionary?.Save[language]}
        </Button>
      </Divider>
      <Table columns={columns} dataSource={teachers} rowKey="id" />
    </>
  );
};

export default TeachersSwitcher;
